import { notifications } from "@mantine/notifications"

import { useExportProductQrCode } from "~/gen/api"
import { useAuth } from "~/store/auth-context"
import { downloadFile } from "~/utils/downloadFile"

export const useExportProductQrCodeMutation = () => {
  const { user } = useAuth()

  return useExportProductQrCode({
    mutation: {
      onSuccess: (response) => {
        downloadFile(
          response.data,
          `${user?.organization?.slug.toLowerCase()}-product-qr-code_${new Date().toJSON().slice(0, 10)}.csv`,
          "text/csv"
        )

        notifications.show({
          title: "Success",
          message: "Product QR Code exported",
          color: "teal",
        })
      },
      onError: (error) => {
        notifications.show({
          title: "Error",
          message: error.message,
          color: "red",
        })
      },
    },
  })
}
